import e from"./defaultTheme.js";import m from"./identifier.js";import o from"../node_modules/@mui/system/esm/useThemeProps/useThemeProps.js";function r({props:r,name:s}){return o({props:r,name:s,defaultTheme:e,themeId:m})}export{r as default};
//# sourceMappingURL=useThemeProps.js.map
